import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M11,16a5.869,5.869,0,0,0,.6,2H10.38V16ZM6.38,17.99h2v-2h-2Zm2-6.15h-2v2h2Zm2-2.13h2v-2h-2Zm0,4.13H11a5.677,5.677,0,0,1,.88-2h-1.5ZM4.13,9.46H7.38a.77.77,0,0,0,.75-.75V6.18L11.4,3.39l3.23,2.53V8.71h1.5V5.56A.731.731,0,0,0,15.84,5l-4-3.14a.74.74,0,0,0-.95,0l-4,3.42a.731.731,0,0,0-.26.57V8H3.38a.74.74,0,0,0-.75.73h0V20.92a.759.759,0,0,0,.75.75h8v-1.5H4.13Zm12.479,7.951a2.175,2.175,0,1,1,2.167-2.183v.008A2.176,2.176,0,0,1,16.609,17.411Zm0-3.085a.911.911,0,1,0,.911.911h0a.909.909,0,0,0-.91-.91Zm0-3.827a4.737,4.737,0,0,0-4.728,4.737.081.081,0,0,1,0,.068,5.358,5.358,0,0,0,1.357,3.641,26.853,26.853,0,0,0,2.874,3.128.559.559,0,0,0,.152.126h.1a.15.15,0,0,0,.084,0h.262a.16.16,0,0,0,.092,0h.085l.059-.042h.059a27.573,27.573,0,0,0,2.975-3.212,5.481,5.481,0,0,0,1.4-3.683h0A4.738,4.738,0,0,0,16.669,10.5Zm3.482,4.813a4.215,4.215,0,0,1-1.138,2.858,26.268,26.268,0,0,1-2.344,2.613,24.291,24.291,0,0,1-2.343-2.613,4.215,4.215,0,0,1-1.121-2.934,3.473,3.473,0,0,1,6.946,0A.242.242,0,0,0,20.091,15.312Z';

const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BuildingPinIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'buildingPin'),
) as IconWithRender;

BuildingPinIcon.displayName = 'BuildingPinIcon';
BuildingPinIcon.propTypes = Icon.propTypes;
BuildingPinIcon.renderIcon = (props) => <BuildingPinIcon {...props} />;
export default BuildingPinIcon;
